module.exports = __webpack_public_path__ + "static/media/21.6652d689.jpg";